import React from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { InfoTableButton } from "../../../../library/button";
import { useDispatch } from "react-redux";
import { changeCampaignsModal } from "../../../../../redux/actions/campaigns";
import EmailStatistics from "./email-statistics";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const activeChannel = useSelector((state) => state.campaigns.activeChannel);

  const channelsLoading = useSelector(
    (state) => state.campaigns.fetchAllChannels.loading
  );

  const creditsLoading = useSelector(
    (state) => state.campaigns.activeChannel.credits.loading
  );
  const credits = useSelector(
    (state) => state.campaigns.activeChannel.credits.data
  );

  const sourceLoading = useSelector(
    (state) => state.campaigns.activeChannel.source?.loading
  );
  const source = useSelector((state) => state.campaigns.activeChannel.source);

  const renderChannelStatus = () => {
    if (!channelsLoading) {
      if (activeChannel.active) {
        return <InfoTableButton color="green" title="Aktiv kanal" />;
      } else {
        return <InfoTableButton color="red" title="Inaktiv kanal" />;
      }
    } else {
      return <InfoTableButton color="gray" title="Laster" />;
    }
  };

  const renderDisplayIcon = () => {
    if (!channelsLoading) {
      switch (activeChannel.type) {
        case "email":
          return <i class="fad fa-at"></i>;
        case "sms":
          return <i class="fa-duotone fa-message-lines"></i>;
        default:
          return <i class="fad fa-exclamation-triangle"></i>;
      }
    } else {
      return <i class="fas fa-circle-notch fa-spin"></i>;
    }
  };

  const renderDisplayName = () => {
    if (!channelsLoading) {
      if (activeChannel.username) {
        return activeChannel.username;
      } else {
        return "Ikke tilgjengelig";
      }
    } else {
      return "Laster inn";
    }
  };

  const renderType = () => {
    if (!channelsLoading) {
      switch (activeChannel.type) {
        case "email":
          return "e-post";
        case "sms":
          return "sms-";
        default:
          return "";
      }
    }
  };

  const renderCredits = () => {
    if (!creditsLoading) {
      return `${credits.used}/${credits.total} ${renderType()}er sendt`;
    } else {
      return "Laster inn..";
    }
  };

  const renderCreditsUsed = () => {
    if (credits.used) {
      return (credits.used / credits.total) * 100;
    }
  };

  const renderDisplaySource = () => {
    if (!channelsLoading && !sourceLoading) {
      if (activeChannel.type === "email") {
        if (source?.status?.domain) {
          return source?.status?.domain;
        } else {
          return "Ikke tilgjengelig";
        }
      } else {
        if (source?.status?.number) {
          return source?.status?.number;
        } else {
          return "Ikke tilgjengelig";
        }
      }
    } else {
      return "Laster inn";
    }
  };

  const handleClickUpgrade = () => {
    if (activeChannel.type === "email") {
      dispatch(changeCampaignsModal({ changeEmailReachModal: true }));
    } else {
      dispatch(changeCampaignsModal({ changeSmsReachModal: true }));
    }
  };

  return (
    <div className="email-channel-details-container">
      <Row
        className={`middle-row ${
          activeChannel.type === "sms" ? "no-bottom" : ""
        }`}
      >
        <Col className="showcase-col my-auto">
          <div className="details-container">
            <Row className="details-row my-auto">
              <Col className="thumbnail-col my-auto">
                <div className="thumbnail-container">
                  <span className="thumbnail-icon">{renderDisplayIcon()}</span>
                </div>
              </Col>
              <Col className="details-col my-auto">
                {renderChannelStatus()}
                <h3 className="details-name">{renderDisplayName()}</h3>
                <span className="details-email">{renderDisplaySource()}</span>
              </Col>
            </Row>
          </div>
        </Col>
        <Col className="statistics-col text-right my-auto">
          <div className="percentage-container">
            <div className="details-container">
              <span className="percentage-title">{renderCredits()}</span>
              <button
                onClick={() => handleClickUpgrade()}
                className="percentage-button"
              >
                Oppgrader nå
              </button>
            </div>
            <div className="progress-container">
              <div className="progress" style={{ display: "flex" }}>
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: renderCreditsUsed() + "%" }}
                  aria-valuenow="0"
                  aria-valuemin="0"
                  aria-valuemax={`${credits.total}`}
                >
                  {renderCreditsUsed()}%
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {activeChannel.type === "email" && <EmailStatistics />}
    </div>
  );
};

export default Index;
